<template>

  <div class="box">
    <div class="demo-login">
      <h3>电路设计及原理仿真实训系统</h3>
      <Login @on-submit="handleSubmit">
        <UserName name="username" />
        <Password name="password" />
        <div class="demo-auto-login">
          <Checkbox v-model="autoLogin" size="large">自动登录</Checkbox>
          <a>忘记密码</a>
        </div>
        <Submit />
      </Login>
      <div class="page-account-other">
        <a href="/register" class="page-account-register">注册账户</a>
      </div>
    </div>
    <vue-particles class="login-background" color="#f2f2f2" :particleOpacity="0.7" :particlesNumber="100" shapeType="circle" :particleSize="6"
                   linesColor="#fff" :linesWidth="1" :lineLinked="true" :lineOpacity="0.4" :linesDistance="150" :moveSpeed="3" :hoverEffect="true"
                   hoverMode="grab" :clickEffect="true" clickMode="push">

    </vue-particles>
  </div>

</template>

<script>
import { login } from "@/api/login";
import { timeFix } from "@/utils/util";
export default {
  name: "Menus",
  props: {},
  setup() {},
  data() {
    return {
      autoLogin: true,
    };
  },
  created() {},
  watch: {},
  methods: {
    handleSubmit(valid, { username, password }) {
      if (!valid) {
        this.$Notice.warning({ title: "登录提醒", desc: "请输入用户名与密码" });
      } else {
        login({ username: username, password: password }).then((res) => {
          if (res.code === 200) {
            sessionStorage.userInfo = JSON.stringify(res.data[0]);
            this.$store.commit("setToken", res.data[0].token);
            this.$router.push({ path: "/dahsboard/console" });
            this.$Notice.success({
              title: res.data[0].name,
              desc: `${timeFix()}，欢迎回来`,
            });
          } else {
            this.$Notice.error({ title: "登录失败", desc: res.message });
          }
        });
      }
    },
  },
};
</script>
<style>
@font-face{
	font-family:youshehei;
	src:url( '../../assets/优设标题黑.TTF' );
}
.box{
  height: 100%;
  position: relative;
  overflow: hidden;
}
.login-background {
  position: absolute;
  top: 0;
  left: 0;
  background: linear-gradient(-180deg, #0e6ab4 0%, #569aed 100%);
  width: 100%;
  height: 100vh;
  z-index: 0;
}
.demo-login {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 400px;
  margin-top: -200px;
  margin-left: -200px;
  z-index: 9999;
  color: #2d8cf0;
  padding: 20px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 0 10px #666;
}
.demo-login h3{
  font-size: 26px;
  text-align: center;
  margin-bottom: 30px;
  margin-top: 20px;
  font-family:youshehei;
  font-weight: 400;
}

.demo-auto-login {
  margin-bottom: 24px;
  text-align: left;
}

.demo-auto-login a {
  float: right;
}

.page-account-other {
  margin: 24px 0;
  text-align: left;
}

.page-account-other img {
  width: 24px;
  margin-left: 16px;
  cursor: pointer;
  vertical-align: middle;
  opacity: 0.7;
  -webkit-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
}

.page-account-register {
  float: right;
}
</style>